import { Link } from "react-router-dom";
import { FaLink } from "react-icons/fa";
import { Chip } from "@nextui-org/react";
import { formatCurrency, formatDateTime } from "@/utils/helpers";
import CourseInfo from "../../components/Table/components/RowView";
import RowView from "../../components/Table/components/RowView";

function ViewOffer({ offer }) {
    const { id, name, brief, price, grade, lectures, createdAt, updatedAt } =
        offer;

    return (
        <div key={id}>
            <CourseInfo title={name} brief={brief} maxName={10} maxBrief={30} />

            <RowView
                name={"السنة الدراسية"}
                brief={
                    grade == 1
                        ? "الصف الأول"
                        : grade == 2
                        ? "الصف الثاني"
                        : "الصف الثالث"
                }
                className={"flex"}
            />
            <RowView
                name={"سعر العرض"}
                brief={formatCurrency(price)}
                className={"flex"}
            />
            <RowView
                name={"تاريخ الانشاء"}
                brief={
                    <div className="flex gap-3">
                        <p>
                            {" "}
                            الساعه : {formatDateTime(createdAt).formattedTime}
                        </p>
                        <p> يوم : {formatDateTime(createdAt).formattedDate}</p>
                    </div>
                }
                className={"flex"}
            />
            {createdAt !== updatedAt && (
                <RowView
                    name={"اخر تحديث"}
                    brief={
                        <div className="flex gap-3">
                            <p>
                                {" "}
                                الساعه :{" "}
                                {formatDateTime(updatedAt).formattedTime}
                            </p>
                            <p>
                                {" "}
                                يوم : {formatDateTime(updatedAt).formattedDate}
                            </p>
                        </div>
                    }
                    className={"flex"}
                />
            )}

            <RowView
                name={"المحاضرات"}
                brief={
                    <div className="py-5">
                        {lectures.map((lecture) => (
                            <Chip
                                key={lecture.id}
                                variant="bordered"
                                className="mx-2 text-lg font-semibold text-blue-color-primary"
                            >
                                {lecture.attributes.name}
                            </Chip>
                        ))}
                    </div>
                }
            />

            <RowView
                name={"رابط العرض"}
                brief={
                    <Link to={`/${grade}/offers/${id}`}>
                        <FaLink />
                    </Link>
                }
                className="flex items-center gap-3"
            />
        </div>
    );
}

export default ViewOffer;
